// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  word-wrap: break-word;
}
body,
div,
dl,
dt,
dd,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  padding: 0;
}
/* .content-wrapper > .tween-one-leaving,
.queue-anim-leaving {
  // position: absolute !important;
  // width: 100%;
} */
.video {
  max-width: 800px;
}
#react-content {
  min-height: 100%;
}
.home-page-wrapper p {
  padding: 0;
  margin: 0;
}
/* 详细页图片或框框的样式;
*/
.contact-wrapper {
  min-height: 720px;
}
.contact-wrapper .contact {
  height: 100%;
  display: flex;
  align-items: center;
  margin-top: 5%;
}
.contact-wrapper .contact-text {
  min-height: 424px;
}
.contact-wrapper .contact-text > *.queue-anim-leaving {
  position: relative !important;
}
.contact-wrapper .contact-text .title-wrapper {
  text-align: left;
}
.contact-wrapper .contact-text .title-wrapper .title-h1 {
  position: relative;
  margin: 0;
  font-size: 30.6px;
  font-weight: 700;
}
.contact-wrapper .contact-text .title-wrapper .sub-title {
  font-size: 16px;
  margin-bottom: 20px;
  color: #3A4597;
  font-family: Montserrat;
  font-weight: 700;
}
.contact-wrapper .contact-text .title-wrapper .title-content {
  position: relative;
  margin-bottom: 64px;
  text-align: left;
}
.contact-wrapper .contact-text ul {
  position: relative;
  display: inline-block;
}
.contact-wrapper .contact-text ul li {
  margin-bottom: 24px;
  font-size: 16px;
}
.contact-wrapper .contact-text ul li .contact-icon {
  display: inline-block;
  width: 30px;
  height: 30px;
  position: absolute;
  margin-top: 10px;
}
.contact-wrapper .contact-text ul li .contact-title,
.contact-wrapper .contact-text ul li .contact-content {
  margin-left: 45px;
  color: rgba(0, 0, 0, 0.8);
}
.contact-wrapper .contact-text ul li .contact-title {
  font-weight: bold;
  margin-bottom: 10px;
}
.contact-wrapper .contact-text ul li .contact-title .qr-code {
  width: 20px;
  height: 20px;
  margin-left: 10px;
  transform: translateY(5px);
}
.contact-wrapper .contact-img {
  padding-top: 120px;
}
@media screen and (max-width: 576px) {
  .contact-wrapper {
    overflow: hidden;
  }
  .contact-wrapper .contact-img {
    padding-top: 0;
  }
  .contact-wrapper .contact {
    display: block;
  }
  .contact-wrapper .contact-img,
  .contact-wrapper .contact-text {
    display: block;
    width: 100%;
  }
  .contact-wrapper .contact-text > h1,
  .contact-wrapper .contact-text > p {
    text-align: center;
  }
  .contact-wrapper .contact-text > h1 {
    margin: 56px auto 16px;
  }
  .contact-wrapper .contact-text p {
    margin-bottom: 32px;
  }
  .contact-wrapper .contact-img {
    margin-top: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/contact/less/common.less","webpack://./src/views/contact/less/index.less","webpack://./src/views/contact/less/feature4.less"],"names":[],"mappings":"AACA;EACE,qBAAA;ACAF;ADGA;;;;;;;;;;;;;;EAcE,SAAA;EACA,UAAA;ACDF;AACA;;;;GAIG;ADKH;EACE,gBAAA;ACHF;ADMA;EACE,gBAAA;ACJF;ADMA;EACE,UAAA;EACA,SAAA;ACJF;AACA;CACC;AClCA;EACC,iBAAA;ADoCF;ACrCC;EAIG,YAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;ADoCJ;AClCI;EACE,iBAAA;ADoCN;ACrCI;EAII,6BAAA;ADoCR;ACxCI;EAQI,gBAAA;ADmCR;AC3CI;EAWM,kBAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;ADmCV;ACjDI;EAkBM,eAAA;EACA,mBAAA;EACA,cAAA;EACA,uBAAA;EACA,gBAAA;ADkCV;ACxDI;EA0BM,kBAAA;EACA,mBAAA;EACA,gBAAA;ADiCV;AC7DI;EAkCI,kBAAA;EACA,qBAAA;AD8BR;ACjEI;EAsCM,mBAAA;EACA,eAAA;AD8BV;ACrEI;EA0CQ,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AD8BZ;AC5EI;;EAmDQ,iBAAA;EACA,yBAAA;AD6BZ;ACjFI;EAwDQ,iBAAA;EACA,mBAAA;AD4BZ;ACrFI;EA4DU,WAAA;EACA,YAAA;EACA,iBAAA;EACA,0BAAA;AD4Bd;ACrBI;EACE,kBAAA;ADuBN;AClBA;EACG;IACC,gBAAA;EDoBF;ECrBC;IAGG,cAAA;EDqBJ;ECxBC;IAMG,cAAA;EDqBJ;ECnBI;;IAEE,cAAA;IACA,WAAA;EDqBN;EClBI;;IAGI,kBAAA;EDmBR;ECtBI;IAOI,sBAAA;EDkBR;ECzBI;IAWI,mBAAA;EDiBR;ECbI;IACE,gBAAA;EDeN;AACF","sourcesContent":["\nbody {\n  word-wrap: break-word;\n}\n\nbody,\ndiv,\ndl,\ndt,\ndd,\nul,\nol,\nli,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin: 0;\n  padding: 0;\n}\n\n/* .content-wrapper > .tween-one-leaving,\n.queue-anim-leaving {\n  // position: absolute !important;\n  // width: 100%;\n} */\n\n.video {\n  max-width: 800px;\n}\n\n#react-content {\n  min-height: 100%;\n}\n.home-page-wrapper p {\n  padding: 0;\n  margin: 0;\n}\n","body {\n  word-wrap: break-word;\n}\nbody,\ndiv,\ndl,\ndt,\ndd,\nul,\nol,\nli,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin: 0;\n  padding: 0;\n}\n/* .content-wrapper > .tween-one-leaving,\n.queue-anim-leaving {\n  // position: absolute !important;\n  // width: 100%;\n} */\n.video {\n  max-width: 800px;\n}\n#react-content {\n  min-height: 100%;\n}\n.home-page-wrapper p {\n  padding: 0;\n  margin: 0;\n}\n/* 详细页图片或框框的样式;\n*/\n.contact-wrapper {\n  min-height: 720px;\n}\n.contact-wrapper .contact {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  margin-top: 5%;\n}\n.contact-wrapper .contact-text {\n  min-height: 424px;\n}\n.contact-wrapper .contact-text > *.queue-anim-leaving {\n  position: relative !important;\n}\n.contact-wrapper .contact-text .title-wrapper {\n  text-align: left;\n}\n.contact-wrapper .contact-text .title-wrapper .title-h1 {\n  position: relative;\n  margin: 0;\n  font-size: 30.6px;\n  font-weight: 700;\n}\n.contact-wrapper .contact-text .title-wrapper .sub-title {\n  font-size: 16px;\n  margin-bottom: 20px;\n  color: #3A4597;\n  font-family: Montserrat;\n  font-weight: 700;\n}\n.contact-wrapper .contact-text .title-wrapper .title-content {\n  position: relative;\n  margin-bottom: 64px;\n  text-align: left;\n}\n.contact-wrapper .contact-text ul {\n  position: relative;\n  display: inline-block;\n}\n.contact-wrapper .contact-text ul li {\n  margin-bottom: 24px;\n  font-size: 16px;\n}\n.contact-wrapper .contact-text ul li .contact-icon {\n  display: inline-block;\n  width: 30px;\n  height: 30px;\n  position: absolute;\n  margin-top: 10px;\n}\n.contact-wrapper .contact-text ul li .contact-title,\n.contact-wrapper .contact-text ul li .contact-content {\n  margin-left: 45px;\n  color: rgba(0, 0, 0, 0.8);\n}\n.contact-wrapper .contact-text ul li .contact-title {\n  font-weight: bold;\n  margin-bottom: 10px;\n}\n.contact-wrapper .contact-text ul li .contact-title .qr-code {\n  width: 20px;\n  height: 20px;\n  margin-left: 10px;\n  transform: translateY(5px);\n}\n.contact-wrapper .contact-img {\n  padding-top: 120px;\n}\n@media screen and (max-width: 576px) {\n  .contact-wrapper {\n    overflow: hidden;\n  }\n  .contact-wrapper .contact-img {\n    padding-top: 0;\n  }\n  .contact-wrapper .contact {\n    display: block;\n  }\n  .contact-wrapper .contact-img,\n  .contact-wrapper .contact-text {\n    display: block;\n    width: 100%;\n  }\n  .contact-wrapper .contact-text > h1,\n  .contact-wrapper .contact-text > p {\n    text-align: center;\n  }\n  .contact-wrapper .contact-text > h1 {\n    margin: 56px auto 16px;\n  }\n  .contact-wrapper .contact-text p {\n    margin-bottom: 32px;\n  }\n  .contact-wrapper .contact-img {\n    margin-top: 20px;\n  }\n}\n","@contact: contact;\n@title-text-color: #3A4597;\n.@{contact}-wrapper {\n  min-height: 720px;\n\n  .@{contact} {\n    height: 100%;\n    display: flex;\n    align-items: center;\n    margin-top: 5%;\n\n    &-text {\n      min-height: 424px;\n\n      > *.queue-anim-leaving {\n        position: relative !important;\n      }\n\n      .title-wrapper {\n        text-align: left;\n\n        .title-h1 {\n          position: relative;\n          margin: 0;\n          font-size: 30.6px;\n          font-weight: 700;\n        }\n\n        .sub-title {\n          font-size: 16px;\n          margin-bottom: 20px;\n          color: @title-text-color;\n          font-family: Montserrat;\n          font-weight: 700;\n        }\n\n        .title-content {\n          position: relative;\n          margin-bottom: 64px;\n          text-align: left;\n        }\n\n      }\n\n      ul {\n        position: relative;\n        display: inline-block;\n\n        li {\n          margin-bottom: 24px;\n          font-size: 16px;\n\n          .@{contact}-icon {\n            display: inline-block;\n            width: 30px;\n            height: 30px;\n            position: absolute;\n            margin-top: 10px;\n          }\n\n          .@{contact}-title,\n          .@{contact}-content {\n            margin-left: 45px;\n            color: rgba(0, 0, 0, 0.8);\n          }\n\n          .@{contact}-title {\n            font-weight: bold;\n            margin-bottom: 10px;\n\n            .qr-code {\n              width: 20px;\n              height: 20px;\n              margin-left: 10px;\n              transform: translateY(5px);\n            }\n          }\n        }\n      }\n    }\n\n    &-img {\n      padding-top: 120px;\n    }\n  }\n}\n\n@media screen and (max-width: 576px) {\n  .@{contact}-wrapper {\n    overflow: hidden;\n    .contact-img{\n      padding-top: 0;\n    }\n    .@{contact} {\n      display: block;\n\n      &-img,\n      &-text {\n        display: block;\n        width: 100%;\n      }\n\n      &-text {\n        > h1,\n        > p {\n          text-align: center;\n        }\n\n        > h1 {\n          margin: 56px auto 16px;\n        }\n\n        p {\n          margin-bottom: 32px;\n        }\n      }\n\n      &-img {\n        margin-top: 20px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
